var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import React from 'react';
var ErrorMessageContainer = function (_a) {
    var errorDataTestId = _a.errorDataTestId, errors = _a.errors, _b = _a.name, name = _b === void 0 ? '' : _b, styles = __rest(_a, ["errorDataTestId", "errors", "name"]);
    return (React.createElement(ErrorMessage, { errors: errors || {}, name: name, render: function (_a) {
            var message = _a.message;
            return (React.createElement(Box, { pos: 'relative' },
                React.createElement(Box, __assign({ "data-testid": errorDataTestId, fontSize: 'xs', mt: '3xs', position: 'absolute' }, styles), message)));
        } }));
};
export default ErrorMessageContainer;
//# sourceMappingURL=ErrorMessageContainer.js.map